<div class="p-1 m-1">
  <h3>Repayment Check</h3>

  <table class="table table-bordered table-custom">
    <tbody>
      <tr>
        <td>Actual Repayment (RM)</td>
        <td>
          {{ repaymentWithCharges | number: "1.2-2" }} <b [ngClass]="{ 'text-danger': getRepaymentDifference() < 0, 'text-success': getRepaymentDifference() >= 0 }">({{ getRepaymentDifference() | number: "1.2-2" }})</b>
        </td>
      </tr>
      <tr>
        <td>System Calculated Repayment (RM)</td>
        <td>
          {{ getTotalSupposedSettlement() | number: "1.2-2" }}
          <div class="d-flex justify-content-end">
            <button class="btn btn-light" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
              @if (isCollapsed) {
                <i class="fas fa-chevron-circle-down"></i>
              }
              @if (isCollapsed == false) {
                <i class="fas fa-chevron-circle-up"></i>
              }
            </button>
          </div>

          <div class="collapse" id="collapseExample" [ngbCollapse]="isCollapsed">
            <h4><b>Breakdown</b></h4>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Loan</th>
                  <th>Principal (RM)</th>
                  <th>Settlement (RM)</th>
                  <th>Based On Date</th>
                </tr>
              </thead>
              <tbody>
                @for (item of supposedSettlement; track item; let i = $index) {
                  <tr>
                    <td>{{ item.loan.LoanCode }}</td>
                    <td>{{ item.loan.Principal }}</td>
                    <td>{{ item.settlement }}</td>
                    <td>
                      <div class="col-12">
                        <mat-form-field class="p-0" style="width: 70%">
                          <input matInput readonly [matDatepicker]="datePicker" name="date" [(ngModel)]="item.date" required />
                          <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                          <mat-datepicker #datePicker name="date"></mat-datepicker>
                        </mat-form-field>
                        <button class="btn btn-dark" (click)="updateSettlementDate(i)"><i class="fas fa-calculator"></i></button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
